/**
 * PanelFilterTabs — the ONE filter control for WorkspacePanel `subheader`
 * slots. Locked TabGroup config (the idea-page Media panel look) so every
 * panel's filters render identically: single-select pills, counts as
 * badges, "All" first where applicable. Owns its horizontal scroll — the
 * subheader slot no longer clips, so dropdowns rendered there stay visible.
 */

import React from "react";
import { TabGroup, TabItem, TabGroupConfig } from "@/components/ui/TabGroup";

export interface PanelFilterOption {
  id: string;
  label: string;
  count?: number;
}

const FILTER_TAB_CONFIG: TabGroupConfig = {
  variant: "navigation",
  size: "sm",
  layout: "horizontal",
  fullWidth: false,
  hasBackground: true,
};

export const PanelFilterTabs: React.FC<{
  options: PanelFilterOption[];
  activeId: string;
  onChange: (id: string) => void;
}> = ({ options, activeId, onChange }) => {
  const items: TabItem[] = options.map((o) => ({
    id: o.id,
    label: o.label,
    badge: o.count,
  }));
  return (
    <div className="w-fit min-w-0 max-w-full overflow-x-auto" data-testid="panel-filters">
      <TabGroup
        items={items}
        activeId={activeId}
        onTabChange={onChange}
        config={FILTER_TAB_CONFIG}
      />
    </div>
  );
};
